export class Total {
  onetime: number;

  constructor(total: number) {
    this.onetime = total;
  }

  public getOnetime(): number {
    return this.onetime;
  }
}
